export default "__VITE_ASSET__BXiSqln8__"